<section class="top-section main-navbar">
  <div class="container-fluid nav-bar">
    <div id="menuOverlay" (click)="closeNav()"></div>
    <div id="mySidenav" class="sidenav">
      <a href="javascript:void(0)" class="closebtn" (click)="closeNav()">&times;</a>

      <div class="logo-div sidemenu-logo-div" routerLink="/">
        <img src="assets/images/pups-logo-header.png" alt="">
      </div>

      <div *ngIf="isBusiness || employee" class="profile-container text-center">
        <a *ngIf="!employee" routerLink="/profile">{{ accountDetails.company_name | slice:0:15}}{{ accountDetails.company_name.length > 15 ? '..' : '' }}</a>
        <a *ngIf="employee" routerLink="/profile">{{ accountDetails.first_name | slice:0:15}}{{ accountDetails.first_name.length > 15 ? '..' : '' }}</a>
     
      </div>
      <li> <a routerLink="/" class="hvr-efx1">{{'Home' | translate}}</a> </li>
      <li *ngIf="login == '2' || isBusiness"> <a routerLink="/dashboard" class="hvr-efx1" [ngClass]="{ 'active': url == 'dashboard'}">{{'Dashboard' | translate}}</a> </li>
      <!-- <li *ngIf="login == '2' || isBusiness"><a class="hvr-efx1"  (click)="openPaymentDetailsModal()" >{{'Payment details' | translate}} </a> </li> -->
      <!-- <li *ngIf="isBusiness && login == '1'" class="mobile-dropdown-item">
        <a href="javascript:void(0)" routerLink="/employees" class="mobile-dropdown-toggle"  [ngClass]="{ 'active': url == 'employees'}">
          {{'Employee mobility' | translate}}
          <i class="fa fa-chevron-down mobile-dropdown-arrow" (click)="toggleMobileEmployeesMenu()"  [ngClass]="{ 'open': mobileEmployeesMenuOpen }"></i>
        </a>
        <ul class="mobile-dropdown-menu" [class.open]="mobileEmployeesMenuOpen">
          <li><a (click)="navigateToAddEmployee(); closeNav()">{{'Hiring' | translate}}</a></li>
          <li><a (click)="navigateToCnssEmployeeRegistration(); closeNav()">{{'CNSS employee registration' | translate}}</a></li>
          <li><a (click)="navigateToCnamgsEmployeeRegistration(); closeNav()">{{'CNAMGS employee registration' | translate}}</a></li>
          <li><a routerLink="/employee-termination" (click)="closeNav()">{{'Termination' | translate}}</a></li>
        </ul>
      </li>
      <li *ngIf="isBusiness"><a *ngIf="login == '1'" (click)="getCnssPage()">{{'DTS' | translate}} </a></li>
      <li>
        <a *ngIf="login == '2'" routerLink="/dependence-list">{{'Dependants' | translate}}</a>
      </li>
      <li>
        <a routerLink="/experience" *ngIf="login == '2'">{{'Experience' | translate}}</a>
      </li>
      <li>
        <a routerLink="/cnss" *ngIf="login == '2'">{{'CNSS' | translate}}</a>
      </li>
      <li>
        <a routerLink="/employee-cnamgs" *ngIf="login == '2'">{{'CNAMGS' | translate}}</a>
      </li>
      <li *ngIf="login && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li> -->
      <li><a routerLink="/profile">{{'Profile' | translate}}</a></li>
      <li><a routerLink="/contact-us">{{'Contact' | translate}}</a></li>
     <li [hidden]="!currentValue"><a (click)="logout()">{{'Logout' | translate}}</a></li>
      <div class="language-container">
        
          <!-- <select  formControlName="lang" (change)="setLang($event.target.value)"  class="bootstrap-select">
                  <option value="en" selected="selected">{{'English' | translate}}</option>
                  <option value="fr">{{'French' | translate}}</option>
                </select> -->
          <div class="toggle-button-cover">
            <div class="button-cover">
              <div class="button r " id="button-6">
                <input type="checkbox" class="checkbox"   (change)="getChangelang($event)" />
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
            </div>
          </div>
       
      </div>
    </div>
    <div id="main">
      <header class="block-header home-header">
        <div class="container-custom">
          <div class="row justify-content-between sub-nav">
            <!-- <div class="notofication_button"><a [routerLink]="['/notfication']"><i class="fa-solid fa-bell"></i></a></div> -->
            <div class="button_container" (click)="openNav()">
              <div><span class="top"></span><span class="middle"></span><span class="bottom">
                </span></div>
            </div>
            <div class="col-sm-2 col-md-2">
              <a class="logo-block" routerLink="">
                <div class="logo-div">
                <img src="assets/images/inner-logo.svg" alt="" class="width-unset">
                </div>
              </a>
            </div>
            <div class="col-10 justify-content-end align-items-center lang-desktop">
              <ul >
                <li [hidden]="!currentValue" ><a (click)="logout()">{{'Logout' | translate}}</a></li>

                <!-- <li *ngIf="login == '2' || isBusiness">
                  <a class="pr-0 nav-link-no-underline"  [ngClass]="{ 'active': url == 'notfication'}" routerLink="/notfication" ><i class="fa-solid fa-bell web-bell-icon"></i></a>
                </li> -->
                <li *ngIf="login == '2' || isBusiness">
                  <!-- <a routerLink="/faq" [ngClass]="{ 'active': url == 'faq'}">{{'FAQ' | translate}}</a> -->
                </li>
              </ul>
            
              <div class="dropdown">
            
    
                  <div class="toggle-button-cover">
                    <div class="button-cover">
               
                      <div class="button r "  id="button-6">
                        <input type="checkbox" class="checkbox"  (change)="getChangelang($event)" />
                        <div class="knobs"></div>
                        <div class="layer"></div>
                      </div>
                    </div>
                  </div>
               
              </div>
            </div>
          </div>
          <hr>
          <div class="top-nav-container">
            <div class="row align-items-center">
              <div class="col-sm-12">
                <ul class="nav-block link-efx justify-content-end" id="page-menu">
                  <li> <a routerLink="/" class="hvr-efx1">{{'Home' | translate}}</a> </li>

                  <li *ngIf="login == '2' " class="dropdown-menu-item">
                    <a routerLink="/dashboard" class="hvr-efx1" [ngClass]="{ 'active': url == 'dashboard'}">{{'Dashboard' | translate}}</a>
                  </li>
                 
                  <li *ngIf="isBusiness" class="dropdown-menu-item">
                    <a routerLink="/dashboard" class="hvr-efx1" [ngClass]="{ 'active': url == 'dashboard'}">{{'Dashboard' | translate}}</a>
                  
                  </li>
                  <!-- <li *ngIf="isBusiness"><a class="hvr-efx1"  (click)="openPaymentDetailsModal()" >{{'Payment details' | translate}} </a></li> -->


                  <!-- <li *ngIf="isBusiness" class="dropdown-menu-item">
                    <a routerLink="/employees" class="hvr-efx1" [ngClass]="{ 'active': url == 'employees'}">{{'Employee mobility' | translate}}</a>
                    <ul class="dropdown-menu">
                      <li> <a (click)="navigateToAddEmployee()">{{'Hiring' | translate}}</a></li>
                      <li class="dropdown-submenu">
                        <a (click)="navigateToCnssEmployeeRegistration()">{{'CNSS employee registration' | translate}} </a>
                        
                      </li>

                      <li class="dropdown-submenu">
                        <a (click)="navigateToCnamgsEmployeeRegistration()">{{'CNAMGS employee registration' | translate}} </a>
                        
                      </li>
                
                      <li>
                        <a  routerLink="/employee-termination">{{'Termination' | translate}}</a>
                      </li>
                    </ul>
                  </li>

                  <li *ngIf="isBusiness"><a *ngIf="login == '1'" (click)="getCnssPage()" [ngClass]="{ 'active': url == 'cnss-reports' || url == 'cnss-reportList' || url == 'cnss-report-view'}">{{'DTS' | translate}} </a></li>

                  <li>
                    <a *ngIf="login == '2'" [ngClass]="{ 'active': url == 'dependence-list'}" routerLink="/dependence-list">{{'Dependants' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/experience" [ngClass]="{ 'active': url == 'experience'}"  *ngIf="login == '2'">{{'Experience' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/cnss"  [ngClass]="{ 'active': url == 'cnss'}" *ngIf="login == '2'">{{'CNSS' | translate}}</a>
                  </li>
                  <li>
                    <a routerLink="/employee-cnamgs" *ngIf="login == '2'">{{'CNAMGS' | translate}}</a>
                  </li>
                  <li *ngIf="login && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li> -->
               
                  <div *ngIf="isBusiness || employee" class="profile-container">
                    <a *ngIf="!employee" routerLink="/profile">{{ accountDetails.company_name | slice:0:15}}{{ accountDetails.company_name.length > 15 ? '..' : '' }}</a>

                    <a *ngIf="employee" routerLink="/profile">{{ accountDetails.first_name | slice:0:15}}{{ accountDetails.first_name.length > 15 ? '..' : '' }}</a>
                 
                  </div>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  </div>
</section>


<section class="modal-section2 bulk-upload-modal getstarted">
  <div class="modal fade" id="headerMessageModal" data-backdrop="true" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="modal-body">
          <div class="parent">
            <div class="image-container">
              <img src="assets/images/header-pending.png">
            </div>
            <div class="text-container text-center mt-5">
              <h4 class="modal-header-txt">{{messageTitle | translate}}</h4>
              <p class="para-light">{{messageDescription | translate }}</p>
            </div>
            <a class="text-center header-pdf-icon" *ngIf="is_cnamgsPdf" [href]="accountDetails?.cnamgs_url" target="_blank" >
              <div class=""><img src="assets/images/cnamgspdf.png"></div>
            </a>
            <a class="text-center header-pdf-icon" *ngIf="is_cnssPdf" [href]="accountDetails?.cnss_url" target="_blank" >
              <div class=""><img src="assets/images/cnsspdf.png"></div>
            </a>
            <div class="button-container justify-content-center mt-4 d-flex">
              <button type="submit" id="submit_btn" class="btn btn-medium" (click)="closeModal()">{{'OK' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
